window.zE('webWidget', 'hide');

window.zE('webWidget:on', 'chat:unreadMessages', (number) => {
  document.querySelectorAll('[data-chat-blip]').forEach((e) => { e.innerHTML = number });
});

window.zE('webWidget:on', 'userEvent', (event) => {
  if (event.action === 'Chat Served by Operator') {
    document.dispatchEvent(new CustomEvent('cs:chatStarted', {
      detail: {
        agent: event.properties.agent
      }
    }));
  }
});
